import React from "react";

import { css } from "@emotion/react";

import cn from "classnames";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { CSS_MQ } from "../../../styles/breakpoints";
import styled from "@emotion/styled";
import { Switcher } from "@swo/storefront";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";
import { fontColor, FONTS } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const HeroImageSwitcher: ReactTFC<{
  elements: Switcher;
  activePagePath: string;
}> = props => {
  return (
    <HeroImageWrapper numberOfElements={props.elements.length}>
      {props.elements.map((e, idx) => {
        return (
          <SwarovskiLink
            key={e.link}
            className={cn({ active: e.link === props.activePagePath })}
            link={e.data}
            isInternal={true}
            scrollToTop={false}
            expectSimilarLayout={true}
            css={styles}
          >
            {e.label}
          </SwarovskiLink>
        );
      })}
    </HeroImageWrapper>
  );
};

const HeroImageWrapper = styled.div<{ numberOfElements: number }>`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.numberOfElements}, minmax(0, 1fr));`};

  margin: 0 20px;
`;

const styles = css`
  ${FONTS.SwarovskiFutura500};

  font-size: 14px;
  letter-spacing: 0.8px;
  text-align: center;
  line-height: 1;

  padding-top: 17px;
  padding-bottom: 14px;

  padding-left: 20px; // out of design sizes - to fit content
  padding-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  ${CSS_MQ.atLeastSm} {
    padding-left: 20px;
    padding-right: 20px;
  }

  ${CSS_MQ.atLeastLg} {
    padding-left: 70px;
    padding-right: 70px;
  }

  text-decoration: none;

  border: 1px solid white;

  &.active {
    background-color: ${CSS_COLORS.White};
    ${fontColor.black};
  }

  &:not(.active) {
    background-color: rgba(0, 0, 0, 0.4); // out of design, higher opacity to boost contrast
    color: ${CSS_COLORS.White};
  }

  &:first-of-type {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:not(:first-of-type) {
    border-left: none;
  }

  &:last-of-type {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
